import { VStack } from '@/package';
import type { Project } from '@/type';

import { ProjectPeriodLabeledObject } from './ProjectPeriodLabeledObject';
import { ProjectStatisticSummary } from './ProjectStatisticSummary';
import { ProjectTotalLabeledObject } from './ProjectTotalLabeledObject';
import { ProjectWorkFlowPerformance } from './ProjectWorkFlowPerformance';

const ProjectStatistics = ({ project }: { project: Project }) => {
  return (
    <VStack gap={1.5} className="h-full w-full overflow-y-auto bg-white p-4">
      <ProjectStatisticSummary project={project} />
      <ProjectWorkFlowPerformance project={project} />
      <ProjectTotalLabeledObject project={project} />
      <ProjectPeriodLabeledObject project={project} />
    </VStack>
  );
};

export default ProjectStatistics;
